import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GCAPListComponent } from './gcap-list.component';

@NgModule({
  imports: [CommonModule, GCAPListComponent],
  exports: [GCAPListComponent],
})
export class GCAPListModule {}
